var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCatAlien(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 352,
    height: 290,
    viewBox: "0 0 352 290",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_d_1108_520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.179 211.674C86.7419 197.291 49.1647 155.697 41.8333 136.329C56.3636 131.516 79.5791 126.387 99.2852 128.869C104.046 129.267 102.214 129.101 105.036 129.725C129.505 135.133 196.976 152.37 257.959 193.704C265.597 198.88 264.74 199.78 268.594 204.561C272.448 209.342 295.942 243.737 295.325 245.454C294.707 247.172 265.294 249.442 235.649 246.295C206.004 243.148 159.725 229.654 119.179 211.674Z",
    fill: "#B8E7A1",
    stroke: "#B8E7A1",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3956 135.689C41.3956 135.689 88.8621 182.099 159.346 209.15C229.829 236.201 296.603 245.431 296.603 245.431",
    stroke: "#363232",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1108_520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.728 62.3318C229.046 63.5254 232.704 61.8016 233.898 58.4817C235.093 55.1618 233.371 51.5028 230.053 50.3093C226.734 49.1157 223.076 50.8395 221.882 54.1594C220.688 57.4793 222.41 61.1382 225.728 62.3318Z",
    fill: "#ECEDA1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M225.96 61.6877C228.922 62.7534 232.188 61.2143 233.255 58.2501C234.321 55.2859 232.783 52.019 229.821 50.9533C226.858 49.8877 223.592 51.4267 222.526 54.3909C221.46 57.3552 222.997 60.622 225.96 61.6877Z",
    stroke: "#C4C584",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3956 135.689C41.3956 135.689 67.3468 198.122 157.794 228.959C248.241 259.796 296.603 245.431 296.603 245.431",
    stroke: "#363232",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.715 62.3658C223.11 70.4499 221.233 75.0802 217.134 83.5259",
    stroke: "#AEAEAE",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.597 128.608C154.488 24.5831 299.61 85.998 264.079 199.787",
    stroke: "#AEAEAE",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1963 136.205C63.3761 127.855 76.9168 126.109 103.128 128.417M263.53 199.102C278.335 217.607 284.199 221.812 296.844 245.273",
    stroke: "#363232",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5987 142.498C78.1013 140.362 79.6001 138.074 82.1152 137.487C84.6302 136.9 86.9852 138.288 87.4828 140.425C87.9804 142.561 86.4813 144.849 83.9665 145.436C81.4514 146.023 79.0962 144.634 78.5987 142.498Z",
    stroke: "#363232",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.445 169.928C112.25 169.091 112.519 168.172 113.225 167.345C113.93 166.52 115.043 165.829 116.406 165.511C117.769 165.193 119.072 165.319 120.069 165.748C121.066 166.177 121.715 166.882 121.91 167.719C122.104 168.555 121.835 169.475 121.129 170.301C120.424 171.127 119.312 171.817 117.949 172.135C116.585 172.453 115.282 172.327 114.285 171.899C113.288 171.47 112.64 170.764 112.445 169.928Z",
    stroke: "#363232",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.351 195.077C159.772 192.59 161.389 190.044 164.025 189.429C166.661 188.814 169.236 190.381 169.815 192.868C170.394 195.355 168.777 197.9 166.141 198.516C163.505 199.131 160.93 197.564 160.351 195.077Z",
    stroke: "#363232",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.057 210.826C207.887 210.099 208.15 209.263 208.87 208.481C209.588 207.703 210.714 207.039 212.089 206.718C213.465 206.397 214.768 206.494 215.756 206.874C216.747 207.256 217.352 207.89 217.521 208.617C217.69 209.344 217.428 210.179 216.707 210.961C215.99 211.74 214.863 212.403 213.488 212.724C212.113 213.045 210.809 212.949 209.822 212.568C208.83 212.186 208.226 211.553 208.057 210.826Z",
    stroke: "#363232",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.906 217.139C264.007 218.09 263.593 219.056 262.74 219.852C261.886 220.649 260.622 221.24 259.144 221.397C257.665 221.554 256.305 221.243 255.304 220.644C254.303 220.045 253.695 219.187 253.594 218.236C253.494 217.285 253.908 216.319 254.761 215.523C255.614 214.727 256.879 214.135 258.357 213.978C259.835 213.821 261.195 214.132 262.197 214.732C263.198 215.33 263.806 216.188 263.906 217.139Z",
    stroke: "#363232",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.053 180.428C222.001 180.769 223.046 180.277 223.387 179.328C223.728 178.38 223.236 177.334 222.288 176.993C221.34 176.652 220.295 177.145 219.954 178.093C219.613 179.042 220.105 180.087 221.053 180.428Z",
    fill: "#363232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.315 188.876C225.263 189.217 226.308 188.724 226.649 187.776C226.99 186.827 226.498 185.782 225.55 185.441C224.602 185.1 223.557 185.592 223.216 186.541C222.875 187.489 223.367 188.535 224.315 188.876Z",
    fill: "#363232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.483 184.963C218.431 185.304 219.476 184.812 219.817 183.863C220.158 182.915 219.666 181.869 218.718 181.528C217.77 181.187 216.725 181.68 216.384 182.628C216.043 183.577 216.535 184.622 217.483 184.963Z",
    fill: "#363232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.73 184.77C228.678 185.111 229.724 184.619 230.065 183.67C230.406 182.721 229.914 181.676 228.966 181.335C228.018 180.994 226.973 181.487 226.632 182.435C226.29 183.384 226.782 184.429 227.73 184.77Z",
    fill: "#363232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.583 110.949C181.286 111.327 183.866 112.012 184.587 112.029C185.308 112.046 185.256 108.148 185.256 108.148C185.256 108.148 185.35 107.212 184.415 107.118C183.479 107.024 181.583 110.949 181.583 110.949Z",
    stroke: "#363232",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.575 132.122C220.189 132.41 222.504 133.741 223.196 133.944C223.889 134.147 224.481 133.168 224.516 131.726C224.55 130.283 225.18 129.488 224.301 129.155C223.422 128.822 220.575 132.122 220.575 132.122Z",
    stroke: "#363232",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.533 168.995C237.345 179.261 247.848 185.115 264.096 198.592",
    stroke: "#363232",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.6 128.239C123.005 132.923 134.184 136.464 154.583 144.154",
    stroke: "#363232",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.257 100.616C187.523 100.184 186.259 100.051 185.66 100.286C174.435 111.281 160.138 132.159 144.127 166.572C168.196 180.122 178.283 184.17 204.096 189.841L228.774 128.645C229.301 127.085 228.906 125.362 227.826 123.56L223.289 125.702L212.801 129.931L188.005 113.98L188.854 111.619L190.504 105.011L189.033 101.014L189.257 100.616Z",
    fill: "#363232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.727 127.144C175.457 129.597 177.308 134.061 178.393 135.987C179.557 134.547 182.369 131.938 184.306 133.023C186.242 134.107 183.477 137.574 181.852 139.171C182.806 140.291 186.277 140.117 187.894 139.89C189.699 134.332 188.354 131.65 187.455 131.003C184.408 128.695 177.997 124.692 176.727 127.144Z",
    fill: "#B6E0A1",
    stroke: "#A6CF92",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.602 143.39C196.027 144.901 198.543 147.115 199.747 148.033C199.235 146.313 200.648 143.508 202.382 143.404C205.74 143.203 204.877 147.696 204.039 149.577C206.428 151.018 210.052 147.456 211.566 145.495C209.917 141.993 205.303 140.899 204.321 140.707C202.711 140.694 201.324 140.55 199.704 140.744C198.083 140.937 196.294 142.588 195.602 143.39Z",
    fill: "#B6E0A1",
    stroke: "#A6CF92",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.558 132.747L171.114 142.527",
    stroke: "#D9D9D9",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.221 158.118L215.787 155.942",
    stroke: "#D9D9D9",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.072 163.31L211.777 164.842",
    stroke: "#D9D9D9",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.01 181.175C182.234 180.127 183.211 179.182 185.22 179.662",
    stroke: "#D9D9D9",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.007 182.76C185.231 181.712 186.209 180.768 188.217 181.248",
    stroke: "#D9D9D9",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.782 176.799C170.289 175.853 170.354 173.83 169.573 173.307",
    stroke: "#D9D9D9",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.363 174.819C166.87 173.873 166.14 172.072 165.377 171.577",
    stroke: "#D9D9D9",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.618 180.407C181.658 174.744 192.541 178.174 196.502 185.937",
    stroke: "#D9D9D9",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.73 177.743C174.662 168.591 161.35 167.197 152.725 168.944",
    stroke: "#D9D9D9",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.708 136.861C128.45 138.611 135.569 139.979 141.555 144.078C141.468 148.75 140.732 150.975 138.355 154.322C134.368 154.748 132.169 154.476 127.987 153.502L110.708 136.861Z",
    fill: "#B1E8E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.297 137.657L166.58 142.393",
    stroke: "#D9D9D9",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.603 152.614C186.496 153.208 192.131 151.5 192.442 149.721C192.753 147.942 186.564 144.261 185.028 145.163C183.492 146.065 184.711 152.019 185.603 152.614Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.372 160.538C188.531 161.699 187.012 161.88 185.527 160.618C184.042 159.357 184.849 155.767 184.926 155.552C185.003 155.338 183.63 158.481 179.553 157.014C175.476 155.548 176.586 153.361 176.128 152.388",
    stroke: "#D9D9D9",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.133 186.338C251.888 194.146 256.122 196.727 255.617 198.196L229.198 194.647L236.133 186.338Z",
    fill: "#B1E8E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.687 144.419C126.898 144.826 131.85 146.711 140.716 149.106",
    stroke: "#363232",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.793 139.649L128.747 153.336",
    stroke: "#363232",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.171 136.93L117.571 143.988",
    stroke: "#363232",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.643 137.801L123.631 150.045",
    stroke: "#363232",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.495 136.781C126.51 136.722 140.87 142.615 141.265 144.212C141.296 147.941 139.933 154.314 136.837 154.5C131.636 154.811 126.486 152.959 126.486 152.959",
    stroke: "#363232",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.681 140.797L134.635 154.484",
    stroke: "#363232",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.907 129.205C121.968 152.421 140.981 167.931 165.777 178.817C190.546 189.691 221.029 195.926 263.977 200.694L264.179 198.88C261.682 198.602 259.228 198.32 256.815 198.033C256.809 197.928 256.786 197.835 256.759 197.762C256.708 197.618 256.629 197.494 256.556 197.395C256.407 197.197 256.198 196.993 255.965 196.793C255.492 196.387 254.809 195.9 253.998 195.368C252.369 194.299 250.145 192.995 247.858 191.717C245.568 190.437 243.204 189.176 241.29 188.191C239.399 187.218 237.895 186.487 237.36 186.294C236.856 186.113 236.308 185.958 235.7 186.067C235.091 186.177 234.534 186.531 233.936 187.101C232.806 188.18 231.265 190.301 228.656 194.096C203.568 189.962 183.636 184.664 166.511 177.146C142.027 166.396 123.223 151.082 103.288 128.011L101.907 129.205ZM230.15 194.34C237.937 195.598 246.219 196.749 255.062 197.822C254.657 197.476 254.036 197.03 253.247 196.512C251.659 195.47 249.468 194.185 247.19 192.912C244.915 191.64 242.564 190.387 240.663 189.409C238.739 188.418 237.328 187.737 236.897 187.582C236.436 187.416 236.177 187.372 235.942 187.415C235.71 187.456 235.389 187.605 234.88 188.092C233.921 189.007 232.557 190.85 230.15 194.34Z",
    fill: "#363232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.224 127.18C192.107 129.659 192.408 132.057 193.563 131.541C194.373 130.862 195.425 129.059 196.91 130.32C197.605 130.911 196.533 132.49 196.133 133.155C196.462 133.855 199.322 133.047 200.386 132.783C199.061 127.845 194.392 126.99 192.224 127.18Z",
    fill: "#B8E7A1",
    stroke: "#A6CF92",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.974 166.997C153.15 145.983 159.215 135.107 171.595 117.248C171.595 117.248 182.679 99.9534 186.377 99.8159C190.074 99.6779 190.619 105.598 189.559 108.544C188.235 112.225 187.415 113.154 188.533 114.779C189.65 116.404 202.298 123.155 208.349 127.288C214.4 131.422 217.058 129.442 221.474 126.628C225.891 123.814 227.405 122.838 228.493 124.016C229.577 125.058 229.561 127.087 228.094 131.211C226.943 134.443 211.666 171.645 204.085 189.843",
    stroke: "#3C3C3C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1108_520",
    x: -14,
    y: -39,
    width: 404.287,
    height: 353.15,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 19.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1108_520"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1108_520",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1108_520",
    x: 221.503,
    y: 49.9308,
    width: 12.7741,
    height: 12.7794,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1108_520"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatAlien);
export default __webpack_public_path__ + "static/media/catAlien.bab95f266068cbd581105fbd4ebde4c9.svg";
export { ForwardRef as ReactComponent };